<template>
  <div class="add-c-type">
     <div
      class="add-c-type-items"
      v-for="(i,index) in $attrs.list"
      :class="{ 'add-c-type-items-active':$attrs.nowCustomType===i.customType }"
      @click="handleClick(i)"
      :key="index"
     >
      {{i.name}}
     </div>
  </div>
</template>

<script>
  export default {
    props:{

    },
    data() {
      return {
      }
    },
    methods:{
      handleClick(item) {
        this.$emit('typeChange',item.customType)
      }
    }
  }
</script>

<style lang='less' scoped>

</style>



// WEBPACK FOOTER //
// src/pages/cashier/components/cashierdiaryTable/dialogComponents/add-c-tab.vue